import { Modal } from '@/components/common/Modal'
import { Button } from '@/components/common/Button'
import { AlertTriangle, Play, RotateCcw } from 'lucide-react'
import type { PersistedBatchState } from '@/hooks/usePersistedBatch'

interface BatchConflictDialogProps {
  isOpen: boolean
  existingBatch: PersistedBatchState
  newFileName: string
  onContinueExisting: () => void
  onRestartNew: () => void
  onCancel: () => void
}

export function BatchConflictDialog({
  isOpen,
  existingBatch,
  newFileName,
  onContinueExisting,
  onRestartNew,
  onCancel,
}: BatchConflictDialogProps) {
  const progressPercent = existingBatch.totalSections > 0
    ? Math.round((existingBatch.resolvedSections / existingBatch.totalSections) * 100)
    : 0

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Bestehenden Import gefunden" size="md">
      <div className="space-y-4">
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle className="h-5 w-5 text-yellow-600" />
            <span className="font-medium text-yellow-800">
              Datei "{newFileName}" hat einen unvollständigen Import
            </span>
          </div>
          <div className="text-sm text-yellow-700">
            <p className="mb-2">
              Es existiert bereits ein Import für diese Datei mit {existingBatch.resolvedSections}/{existingBatch.totalSections} Seiten verarbeitet ({progressPercent}%).
            </p>
            <p>
              Möchten Sie den bestehenden Import fortsetzen oder einen neuen starten?
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <Button
            variant="primary"
            size="sm"
            onClick={onContinueExisting}
            className="flex items-center justify-center gap-2"
          >
            <Play className="h-4 w-4" />
            Fortsetzen ({progressPercent}%)
          </Button>
          
          <Button
            variant="secondary"
            size="sm"
            onClick={onRestartNew}
            className="flex items-center justify-center gap-2 text-red-600 border-red-300 hover:bg-red-50"
          >
            <RotateCcw className="h-4 w-4" />
            Neu starten
          </Button>
        </div>

        <div className="text-xs text-gray-500 text-center">
          Neu starten entfernt den bestehenden Import und beginnt von Anfang.
        </div>

        <div className="flex justify-end pt-2 border-t">
          <Button variant="secondary" size="sm" onClick={onCancel}>
            Abbrechen
          </Button>
        </div>
      </div>
    </Modal>
  )
}